import { type SidebarGroup } from '@app/helpers';

export const ACTION_SET_SIDEBAR_GROUPS = 'ACTION_SET_SIDEBAR_GROUPS';
export const ACTION_SET_SIDEBAR_IS_EXPANDED = 'ACTION_SET_SIDEBAR_IS_EXPANDED';
export const ACTION_SET_MOBILE_SIDEBAR_IS_OPEN = 'ACTION_SET_MOBILE_SIDEBAR_IS_OPEN';
export const ACTION_SET_MOBILE_USER_NAVIGATION_IS_OPEN = 'ACTION_SET_MOBILE_USER_NAVIGATION_IS_OPEN';
export const ACTION_SET_MOBILE_SHARE_MODAL_IS_OPEN = 'ACTION_SET_MOBILE_SHARE_MODAL_IS_OPEN';
export const ACTION_SET_MOBILE_TRANSFER_MODAL_IS_OPEN = 'ACTION_SET_MOBILE_TRANSFER_MODAL_IS_OPEN';
export const ACTION_SET_NEW_VERSION_AVAILABLE = 'ACTION_SET_NEW_VERSION_AVAILABLE';
export const ACTION_SET_YAT_REDIRECT_MODAL_IS_OPEN = 'ACTION_SET_YAT_REDIRECT_MODAL_IS_OPEN';
export const ACTION_SET_TWITTER_CONNECT_IS_OPEN = 'ACTION_SET_TWITTER_CONNECT_IS_OPEN';
export const ACTION_SET_EMAIL_PREFERENCES_IS_OPEN = 'ACTION_SET_EMAIL_PREFERENCES_IS_OPEN';

export interface DashboardState {
    sidebar: SidebarGroup;
    sidebarIsExpanded: boolean;
    mobileSidebarIsOpen: boolean;
    mobileUserNavigationIsOpen: boolean;
    mobileShareModalIsOpen: boolean;
    mobileTransferModalIsOpen: boolean;
    newVersionAvailable: boolean;
    yatRedirectModalIsOpen: boolean;
    twitterConnectIsOpen: boolean;
    emailPreferencesIsOpen: boolean;
}

interface SetSidebarGroups {
    type: typeof ACTION_SET_SIDEBAR_GROUPS;
    sidebarGroups: SidebarGroup;
}

interface SetSidebarIsExpanded {
    type: typeof ACTION_SET_SIDEBAR_IS_EXPANDED;
    sidebarIsExpanded: boolean;
}

interface SetMobileSidebarIsOpen {
    type: typeof ACTION_SET_MOBILE_SIDEBAR_IS_OPEN;
    mobileSidebarIsOpen: boolean;
}

interface SetMobileUserNavigationIsOpen {
    type: typeof ACTION_SET_MOBILE_USER_NAVIGATION_IS_OPEN;
    mobileUserNavigationIsOpen: boolean;
}

interface SetMobileShareModalIsOpen {
    type: typeof ACTION_SET_MOBILE_SHARE_MODAL_IS_OPEN;
    mobileShareModalIsOpen: boolean;
}

interface SetMobileTransferModalIsOpen {
    type: typeof ACTION_SET_MOBILE_TRANSFER_MODAL_IS_OPEN;
    mobileTransferModalIsOpen: boolean;
}

interface SetNewVersionAvailable {
    type: typeof ACTION_SET_NEW_VERSION_AVAILABLE;
    refresh: boolean;
}

interface SetYatRedirectModalIsOpen {
    type: typeof ACTION_SET_YAT_REDIRECT_MODAL_IS_OPEN;
    yatRedirectModalIsOpen: boolean;
}
interface SetTwitterConnectIsOpen {
    type: typeof ACTION_SET_TWITTER_CONNECT_IS_OPEN;
    twitterConnectIsOpen: boolean;
}
interface SetEmailPreferencesIsOpen {
    type: typeof ACTION_SET_EMAIL_PREFERENCES_IS_OPEN;
    emailPreferencesIsOpen: boolean;
}

export type DashboardActionTypes =
    | SetSidebarGroups
    | SetSidebarIsExpanded
    | SetMobileSidebarIsOpen
    | SetMobileUserNavigationIsOpen
    | SetMobileShareModalIsOpen
    | SetMobileTransferModalIsOpen
    | SetNewVersionAvailable
    | SetYatRedirectModalIsOpen
    | SetTwitterConnectIsOpen
    | SetEmailPreferencesIsOpen;
